import React, { useContext, useState, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import { CruiseSelectionContext } from 'contexts/CruiseSelectionContext';
import { Title, Label } from '../Banners.styled';
import Banner, { PROMO_APPLIED, PROMO_SOLDOUT, PROMO_ERROR, PROMOTION_STATUS_ACTIVE, PROMOTION_STATUS_EXPIRED,
  PROMOTION_STATUS_UPCOMING } from '../../Components/Banner';
import { getColorFont, getFontFamily } from '../utils';


const PromotionsBanner = ({promotions})=> {
  const {
    globalization,
  } = useContext(CruiseSearchContext);
  const { isMobile } = useContext(CruiseSelectionContext);

  const { generalDictionary } =
    globalization?.dictionaries || {};
  
  const {
    labelPromotionAppliedTitle,
    labelPromotionAppliedDetails,
    labelPromotionUnavailableTitle,
    labelPromotionUnavailableDetails,
    labelPromotionErrorTitle,
    labelPromotionErrorDetails,
  } = generalDictionary;

  const [close, setClose] = useState(false);

  const promotionApplied = promotions.status === PROMOTION_STATUS_ACTIVE;

  const promotionExpired = promotions.status === PROMOTION_STATUS_EXPIRED;

  const promotionUpcoming = promotions.status === PROMOTION_STATUS_UPCOMING;
  
  const getErrorCode = promotions?.errorMessage?.map(e => e.extensions.exception?.code)
  const promotionNotExist = getErrorCode?.toString() === "WAR_001";

  const getInfoError = promotions => {
    const isErrService = promotions?.errorMessage?.map(e => e.extensions.exception?.code).toString()
    const errorCode = isErrService?.startsWith('ERR_')

    return errorCode
  };

  const typeBanner = useMemo(
    () => {
      if(promotionApplied) return PROMO_APPLIED;
      if(promotionNotExist) return PROMO_SOLDOUT;
      if(getInfoError(promotions)) return PROMO_ERROR;
      else return PROMO_SOLDOUT;
    },[promotionApplied, promotionNotExist, getErrorCode]
  );

  const getTitle = useMemo(
    () => {
      if (promotionApplied) return labelPromotionAppliedTitle;
      if(promotionNotExist) return labelPromotionUnavailableTitle;
      if(getInfoError(promotions)) return labelPromotionErrorTitle;
      else return labelPromotionUnavailableTitle;
    },[promotionApplied, promotionNotExist, getInfoError]
  )

  const getContent = useMemo(
    () => {
      if(promotionApplied) return labelPromotionAppliedDetails;
      if(promotionNotExist) return labelPromotionUnavailableDetails;
      if(getInfoError(promotions)) return labelPromotionErrorDetails;
      else return labelPromotionUnavailableDetails;
    },[promotionApplied, promotionNotExist, getInfoError]
  )

  const getBanner = useCallback(() => {
    return (<Banner
    onClose={() => {
      setClose(true);
    }}
    type={typeBanner}
    titleBanner={
      <Title $color={getColorFont(isMobile, typeBanner)} $fontFamily={getFontFamily(isMobile)}>
        {getTitle}
      </Title>
    }
    contentBanner={
      <Label $weight="400">{getContent}</Label>
    }
  />)

  }, [
    promotionExpired, promotionUpcoming, promotionApplied
  ]);

  if (close) return null;

  return <>{getBanner()}</>;
};

PromotionsBanner.propTypes = {
  promotions: PropTypes.any,
};

PromotionsBanner.defaultProps = {
  promotions: {},
};

export default PromotionsBanner;
